import React from 'react';
import { queries } from '../../../graphql/graphql';
import ListContainer, { ListItem } from '../../../components/containers/AdminList';
import { Card, Image } from 'antd';
import { Link } from 'react-router';

const imageStyle: React.CSSProperties = {
  aspectRatio: '1 / 1',
  objectFit: 'cover',
  width: '100%',
};

interface CustomCardProps {
  item: ListItem;
  refetch: () => void;
  prefix: string;
  role?: string;
}

const CustomCard: React.FC<CustomCardProps> = ({ item }) => {
  const getActions = (item: ListItem) => {
    return [
      <Link key={`link-${item.id}`} to={`/site-visit/${item.id}`}>
        View
      </Link>,
      <Link key={`edit-${item.id}`} to={`/site-visit/edit/${item.id}`}>
        Edit
      </Link>,
    ];
  };
  const preview = item.preview as { original?: string } | undefined;
  return (
    <Card
      hoverable
      cover={<Image preview={false} alt="" src={preview?.original} style={imageStyle} />}
      actions={getActions(item)}>
      <Card.Meta
        title={(item.title || '').toUpperCase()}
        description={
          <div>
            <p>{item.map?.address || 'Address is empty'}</p>
            <p style={{ fontSize: '12px', color: '#666' }}>User ID: {item.userId as string}</p>
          </div>
        }
        style={{ minHeight: 100 }}
      />
    </Card>
  );
};

const ListSiteVisit: React.FC = () => {
  return (
    <ListContainer
      prefix="site-visit"
      query={queries.siteVisit.ADMIN_SITE_VISIT_LIST}
      inline={false}
      editable={true}
      canCreate={false}
      adminView={true}
      CustomCard={CustomCard}
    />
  );
};

export default ListSiteVisit;
